export default "__VITE_ASSET__72f9409f__"